// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_2XH6l","icon":"_496XX"};